import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { MaterialIcons } from "@expo/vector-icons";
import Colors from "../../../Resources/Color";
import { useDevice } from "../../_layout";
import Exercise from "../../Firestore/Exercise";

const ClipboardExerciseCard = observer(({ exercise }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useDevice();

  const exerciseDisplayName = (() => {
    const directName = exercise?.getName?.(t, i18n.language);
    if (directName) return directName;

    const hasOriginalName =
      typeof exercise?.originalName === "string" &&
      exercise.originalName.trim() !== "";

    if (hasOriginalName && Exercise?.prototype?.getName) {
      try {
        const localizedName = Exercise.prototype.getName.call(
          exercise,
          t,
          i18n.language,
        );
        if (localizedName) return localizedName;
      } catch {}
    }

    return exercise?.name || t("exercise-string");
  })();

  const protocolSlot =
    typeof exercise?.protocolSlot === "string" &&
    exercise.protocolSlot.trim() !== ""
      ? exercise.protocolSlot
      : null;

  return (
    <View style={styles.exerciseCard}>
      <View style={styles.exerciseHeader}>
        <View style={styles.exerciseMoveHandle}>
          <MaterialIcons
            name="drag-indicator"
            size={16}
            color={Colors.bubbleColor}
          />
        </View>
        <View style={styles.exerciseTitleBlock}>
          <View style={styles.exerciseNameRow}>
            <Text
              style={styles.exerciseName}
              numberOfLines={2}
              adjustsFontSizeToFit={true}
              minimumFontScale={0.88}
            >
              {exerciseDisplayName}
            </Text>
          </View>

          {protocolSlot && (
            <View style={styles.exerciseProtocolSlotRow}>
              <Text style={styles.exerciseProtocolSlotText} numberOfLines={1}>
                {t(protocolSlot)}
              </Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  exerciseCard: {
    paddingVertical: 4,
    paddingLeft: 0,
    paddingRight: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "transparent",
    outlineStyle: "none",
    gap: 8,
    cursor: "default",
  },
  exerciseHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  },
  exerciseTitleBlock: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  exerciseNameRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
  },
  exerciseName: {
    fontSize: 13,
    fontWeight: "500",
    color: Colors.whiteColor,
    flexShrink: 1,
    minWidth: 0,
  },
  exerciseProtocolSlotRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  exerciseProtocolSlotText: {
    fontSize: 11,
    fontWeight: "500",
    color: Colors.grayColor,
    flexShrink: 1,
  },
  exerciseMoveHandle: {
    padding: 1,
  },
});

export default ClipboardExerciseCard;
